module.exports = __webpack_public_path__ + "static/img/quickwire_256.5d421d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickwire_256.png
// module id = 8sgc
// module chunks = 0